// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__zrs2Z","footer":"ModalCreateQualiphyProcedure_footer__3aAN2","additionData":"ModalCreateQualiphyProcedure_additionData__3iQV1"};